export const judgeData = [
    {
        name: 'Dr. Saif Ali',
        qualifications: 'Interdisciplinary Scientist, Assitant Professor',
        imag: require('../assets/saifsir.jpg'),
    }, {
        name: 'Dr. Navaid Z. Rizvi',
        qualifications: 'Passionate Educator, Scitech Visionary, Inspirational Speaker',
        imag: require('../assets/navedsir.jpg')
    }, {
        name: 'Aman Malik',
        qualifications: 'Tech lead and Sr. software developer at M16LABS',
        imag: require('../assets/Aman.jpg')
    }
]